function onNostoLoad() {
    console.log('Nosto being loaded...');
    let $elHTML = document.querySelector('html');
    //$elHTML.classList.add('display-products');

    $elHTML.classList.add('display-products');
    // setTimeout(() => {
    //     $elHTML.classList.add('display-products');
    // }, 400); // Delay of 1 second
    
}

// wait for all transistion to complete and then change it
document.addEventListener('DOMContentLoaded', function() {
    const collectionDivs = document.querySelectorAll('body.collection main div');
    const seoCollection = document.querySelectorAll('.colllection-seo-new');

    collectionDivs.forEach(div => {        
        setTimeout(() => {
            div.style.transition = 'all 0s ease 0s'; // Removes any transition effect
        }, 4000); // Delay in milliseconds
    })

    seoCollection.forEach(div => {
        setTimeout(() => {
            div.style.opacity = 1;
        }, 500);
    })
})